import Vue from "vue";
import VueRouter from "vue-router";
// import store from "@/store";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    redirect: "/home",
  },
  {
    path: "/home",
    component: () =>
      import(
        /* webpackChunkName: "demo-home-layout" */ "@/layouts/DemoHomeLayout.vue"
      ),
    children: [
      {
        path: "",
        name: "DemoHome",
        component: () =>
          import(
            /* webpackChunkName: "demo-home" */ "@/views/demo/DemoHome.vue"
          ),
      },
    ],
  },
  {
    path: "/dashboard",
    component: () =>
      import(
        /* webpackChunkName: "demo-ops-layout" */ "@/layouts/OperationsDashboardLayout.vue"
      ),
    children: [
      {
        path: "",
        name: "DemoOperationsDashboard",
        component: () =>
          import(
            /* webpackChunkName: "demo-operations" */ "@/views/demo/OperationsDashboard.vue"
          ),
        meta: {
          menuKey: "ops-overview",
        },
      },
      {
        path: "product",
        name: "DemoOperationsProduct",
        component: () =>
          import(
            /* webpackChunkName: "demo-ops-product" */ "@/views/demo/OperationsProductInventory.vue"
          ),
        meta: {
          menuKey: "ops-product",
        },
      },
    ],
  },
  {
    path: "/finance",
    component: () =>
      import(
        /* webpackChunkName: "demo-finance-layout" */ "@/layouts/FinanceDemoLayout.vue"
      ),
    children: [
      {
        path: "",
        name: "DemoFinanceCfo",
        component: () =>
          import(
            /* webpackChunkName: "demo-finance-cfo" */ "@/views/demo/FinanceCfoDashboard.vue"
          ),
        meta: {
          menuKey: "fin-pl",
        },
      },
      {
        path: "statements",
        name: "DemoFinanceStatements",
        component: () =>
          import(
            /* webpackChunkName: "demo-finance-statements" */ "@/views/demo/FinanceStatementsDashboard.vue"
          ),
        meta: {
          menuKey: "fin-bs",
        },
      },
    ],
  },
  {
    path: "/factory",
    component: () =>
      import(
        /* webpackChunkName: "demo-factory-layout" */ "@/layouts/FactoryMonitoringLayout.vue"
      ),
    children: [
      {
        path: "",
        name: "DemoFactoryLine",
        component: () =>
          import(
            /* webpackChunkName: "demo-factory" */ "@/views/demo/FactoryLineDashboard.vue"
          ),
        meta: {
          menuKey: "fac-board",
        },
      },
      {
        path: "quality",
        name: "DemoFactoryQuality",
        component: () =>
          import(
            /* webpackChunkName: "demo-factory-quality" */ "@/views/demo/FactoryQualityDashboard.vue"
          ),
        meta: {
          menuKey: "fac-quality",
        },
      },
    ],
  },
];

const router = new VueRouter({
  mode: "history",
  base: "/demo/",
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
});

router.afterEach((to) => {
  if (to.meta && to.meta.title) {
    document.title = to.meta.title;
  }
});

export default router;
